import { render, staticRenderFns } from "./CreateInvoicesPage.vue?vue&type=template&id=5e15a6d0&"
import script from "./CreateInvoicesPage.vue?vue&type=script&lang=ts&"
export * from "./CreateInvoicesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports